import { _callBackend } from './api';
import type { QuestionnaireTemplate } from '@/_types/models/questionnaireTemplate';
import type { APIRequest, APIResponsePromise } from '@/_types/api';

export const getQuestionnaireTemplate = async ({
  token,
  questionnaireTemplateId,
}: APIRequest<{
  questionnaireTemplateId: number;
}>): APIResponsePromise<QuestionnaireTemplate> =>
  await _callBackend(
    `/questionnaire_templates/get_template_by_id?template_id=${questionnaireTemplateId}`,
    'GET',
    null,
    token,
  );
